"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_COUNTRY = 'se';
var DEFAULT_LANGUAGE = 'sv';
var DEFAULT_UI_PLATFORM = 'irw';
/**
 * Provide with URL utility functions.
 */

var UrlUtility = /*#__PURE__*/function () {
  function UrlUtility() {
    _classCallCheck(this, UrlUtility);
  }

  _createClass(UrlUtility, null, [{
    key: "getAppInfo",

    /**
     * Returns application information from query string.
     *
     * @returns {{ country: string, language: string, uiPlatform: string }} Country, Language and UI platform in an object. Default values: { country: 'se', language: 'sv', uiPlatform: 'irw' }.
     */
    value: function getAppInfo() {
      if (this._appInfo) {
        return this._appInfo;
      }

      var query = this.getCombinedQuery();
      var country = DEFAULT_COUNTRY;
      var language = DEFAULT_LANGUAGE;

      if (query.locale) {
        var locale = query.locale.split('_');

        if (locale.length > 1 && locale[0].length === 2 && locale[1].length === 2) {
          country = locale[1].toLowerCase();
          language = locale[0].toLowerCase();
        }
      }

      this._appInfo = {
        country: country,
        language: language,
        uiPlatform: query.uiPlatform || DEFAULT_UI_PLATFORM,
        storeId: query.storeId || null,
        applicationName: query.applicationName || null,
        seriesGallery: {
          applications: query.applications ? query.applications.split(',') : [],
          defaultApplication: query.defaultApplication || null
        }
      };
      return this._appInfo;
    }
    /**
     * Returns the query string merged with both search and hash as variables.
     *
     * @returns {object} Object with key value pairs of the data in the query string.
     */

  }, {
    key: "getCombinedQuery",
    value: function getCombinedQuery() {
      return Object.assign(this.getSearchQuery(), this.getHashQuery());
    }
    /**
     * Returns the query string as variables.
     *
     * @returns {object} Object with key value pairs of the data in the query string.
     */

  }, {
    key: "getSearchQuery",
    value: function getSearchQuery() {
      var search = window.location.search ? window.location.search.substring(1) : '';
      return this._parseQueryString(search);
    }
    /**
     * Sets search query.
     *
     * @param {object} query Query to set.
     */

  }, {
    key: "setSearchQuery",
    value: function setSearchQuery(query) {
      window.location.href = window.location.href.split('?')[0] + this.buildQueryString(query);
    }
    /**
     * Returns the query string defined in hash as variables.
     *
     * @returns {object} Object with key value pairs of the data in the query string.
     */

  }, {
    key: "getHashQuery",
    value: function getHashQuery() {
      var hash = window.location.hash ? window.location.hash.split('?').reverse()[0] : '';
      return this._parseQueryString(hash);
    }
    /**
     * Sets hash query.
     *
     * @param {object} query Query to set.
     */

  }, {
    key: "setHashQuery",
    value: function setHashQuery(query) {
      window.location.hash = '#' + window.location.hash.split('?')[0].replace('#', '') + this.buildQueryString(query);
    }
    /**
     * Builds search query.
     *
     * @param {object} query Query to build.
     * @returns {string} Query string.
     */

  }, {
    key: "buildQueryString",
    value: function buildQueryString(query) {
      var queryString = [];

      for (var _i = 0, _Object$keys = Object.keys(query); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        queryString.push(key + '=' + query[key]);
      }

      return '?' + queryString.join('&');
    }
    /**
     * Clears cache.
     */

  }, {
    key: "clearCache",
    value: function clearCache() {
      delete this._appInfo;
    }
    /**
     * Parses a query.
     *
     * @param {string} queryString Query string.
     * @returns {object} Object with key value pairs of the data in the query string.
     */

  }, {
    key: "_parseQueryString",
    value: function _parseQueryString(queryString) {
      var variables = queryString.split('&');
      var query = {};

      var _iterator = _createForOfIteratorHelper(variables),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var variable = _step.value;

          if (variable) {
            var pair = variable.split('=');
            query[pair[0]] = pair[1];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return query;
    }
  }]);

  return UrlUtility;
}();

exports.default = UrlUtility;